var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo
    ? _c(
        "div",
        [
          _c("print-preview-with-side-view", {
            attrs: {
              emailer: _vm.emailer,
              "report-name": _vm.reportName,
              parameters: _vm.parameters,
              "parameter-id": _vm.parameterId,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "side-bar",
                  fn: function () {
                    return [
                      _c("debtor-aging-report-side-menu", {
                        on: { ok: _vm.okButton },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              135611614
            ),
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }